import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { Observable } from 'rxjs';
import { ScheduledMeetingNotesResponse } from '../../models/schedule-mentor-call-meetingnotes/scheduledMeetingNotesResponse';
import { ScheduledMeetingNotesRequest } from '../../models/schedule-mentor-call-meetingnotes/scheduledMeetingNotesRequest';
import { MentorNotesForStudentResponse } from '../../models/mentor-notes-for-student/mentorNotesForStudentResponse';
import { MentorNotesForStudentRequest } from '../../models/mentor-notes-for-student/mentorNotesForStudentRequest';

@Injectable({
  providedIn: 'root'
})
export class ScheduleMentorCallMeetingnotesService {

  constructor(private genericService: GenericService) { }

  updateScheduledMeetingNotes(req: ScheduledMeetingNotesRequest): Observable<ScheduledMeetingNotesResponse>
  {
    return this.genericService.put(`scheduledmeetingnotes`, req);
  }
  getScheduledMeetingNotes(meetingid: number): Observable<ScheduledMeetingNotesResponse>
  {
    return this.genericService.get(`scheduledmeetingnotes/${meetingid}`);
  }
  deleteScheduledMeetingEndPoint(meetingid: number):Observable<ScheduledMeetingNotesResponse>
  {
    return this.genericService.delete(`scheduledmeetingnotes/${meetingid}`);
  }

  //Student Notes For Mentor API's
  getMentorNotesForStudent(studentid: string): Observable<any>
  {
    return this.genericService.get(`mentor/notes-for-student/${studentid}`)
  }
  addMentorNotesForStudent(req: MentorNotesForStudentRequest): Observable<MentorNotesForStudentResponse>
  {
    return this.genericService.put(`mentor/notes-for-student`, req);
  }
  deleteMentorNotesForStudent(studentid: string, noteid: string)
  {
    return this.genericService.delete(`mentor/notes-for-student/${studentid}/note/${noteid}`);
  }
}
